import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  value: number;
  max: number;
  label?: string;
  valueLabel?: string;
}

export function ProgressBar({ value, max, label, valueLabel }: ProgressBarProps) {
  const ratio = max > 0 ? Math.min(1, Math.max(0, value / max)) : 0;

  return (
    <div className={styles.wrapper}>
      {(label || valueLabel) && (
        <div className={styles.meta}>
          <span>{label}</span>
          <span className={styles.metaValue}>{valueLabel}</span>
        </div>
      )}
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <div className={styles.fill} style={{ width: `${ratio * 100}%` }} />
      </div>
    </div>
  );
}
